module.exports = __webpack_public_path__ + "static/media/safety.464cbe6a.svg";